import { IAutoRangeBucket } from '../redux/slices/oldBuilder/binning/types';
import {
  BucketDefType,
  BucketKind,
  IBucketDefFieldsFragment,
  INamedBucketDef,
  IRangeBucket,
} from './apollo/graphqlSchema';

export const BIN_STEP_DECIMAL_PLACE = 4;

export const getBinningDisplay = (bucketDef: IBucketDefFieldsFragment) => {
  // basic binning has a single label
  if (bucketDef.type === BucketDefType.Basic) {
    return 'Custom';
  }

  // named binning has its own name
  return (bucketDef as INamedBucketDef).name;
};

const getIntegerNumberIfPossible = (value: number) => {
  if (Number.isInteger(value)) {
    return value;
  } else {
    return Number(value.toFixed(BIN_STEP_DECIMAL_PLACE));
  }
};

/**
 *
 * @param autoRangeBucket must passing a VALID autoRangeBucket by check with isValidAutoRangeBucketInput()
 * @returns expanded range buckets
 */
export const getExpandedRangeBuckets = (
  autoRangeBucket: IAutoRangeBucket,
): IRangeBucket[] => {
  let rangeBuckets: IRangeBucket[] = [];
  const { min, max, binCount } = autoRangeBucket;
  const minValue = Number(min);
  const maxValue = Number(max);
  const binCountValue = Number(binCount);
  if (maxValue - minValue >= binCountValue) {
    const step = Math.ceil((maxValue - minValue) / binCountValue);
    for (let i = 0; i < binCountValue; i++) {
      // for the special case, when use ceil(), it might reach the end of range ealier.
      if (i > 0 && rangeBuckets[i - 1].max === maxValue) {
        break;
      }
      rangeBuckets.push({
        __typename: 'RangeBucket',
        name: '',
        kind: BucketKind.Range,
        min: minValue + step * i,
        max:
          minValue + step * (i + 1) > maxValue
            ? maxValue
            : minValue + step * (i + 1),
        isCustomName: false,
      });
    }
  } else {
    // in this case, we cannot split each group by integer,
    // then use float and round to decimal 4 places.
    const step = Number(
      ((maxValue - minValue) / binCountValue).toFixed(BIN_STEP_DECIMAL_PLACE),
    );

    for (let i = 0; i < binCountValue; i++) {
      // for the special case, when use ceil(), it might reach the end of range ealier.
      if (i > 0 && rangeBuckets[i - 1].max === maxValue) {
        break;
      }
      const currMin = minValue + step * i;
      const currMax = minValue + step * (i + 1);
      rangeBuckets.push({
        __typename: 'RangeBucket',
        name: '',
        kind: BucketKind.Range,
        min: getIntegerNumberIfPossible(currMin),
        max:
          // because of the round, it might have overflow, or less than maxValue at the last step
          currMin > maxValue || (currMin < maxValue && i === binCountValue - 1)
            ? getIntegerNumberIfPossible(maxValue)
            : getIntegerNumberIfPossible(currMax),
        isCustomName: false,
      });
    }
  }

  return rangeBuckets;
};
